import React from 'react';
import { EmptyBar, EmptyChart, EmptyDonut } from '@icons';
import { BarLineChart, FileSearch } from '@images';

export type LeadDataCardType =
  | 'location'
  | 'donutChart'
  | 'barLineChart'
  | 'fileSearch'
  | 'funnel';

interface EmptyLeadDataStateProps {
  cardType: LeadDataCardType;
}

const EmptyLeadDataState: React.FC<EmptyLeadDataStateProps> = ({
  cardType
}) => {
  const renderIcon = () => {
    switch (cardType) {
      case 'location':
        return <EmptyBar />;
      case 'donutChart':
        return <EmptyDonut />;
      case 'barLineChart':
        return <BarLineChart />;
      case 'funnel':
        return <EmptyChart />;
      case 'fileSearch':
        return <FileSearch />;
      default:
        return <EmptyBar />;
    }
  };

  return (
    <div className="flex size-full flex-1 flex-col items-center justify-center">
      {renderIcon()}
      <div className="mb-4 mt-[32px] text-center align-middle text-base font-medium leading-none text-[#333333]">
        No Lead Data Available
      </div>
      <div className="text-center align-middle text-[14px] font-normal text-[#7E7E7E]">
        Looks like you have not added any data yet.
      </div>
    </div>
  );
};

export default EmptyLeadDataState;
